import "react-toastify/dist/ReactToastify.css";
import UserImage from '../../img/user.jpg';
import {useEffect, useState} from 'react';

import {Sidenav, Nav, Button, Modal} from 'rsuite';
import {ArrowLeft} from "@rsuite/icons";
import AuthService from "../../services/auth.service";
import Physical from "./physical/physical";
import Subscription from "./subscription/subscription";
import Account from "./account/account";
import {useNavigate, useParams} from "react-router-dom";
import Dashboards from "./dashboard/dashboard";
import './sidebar.scss';
import CloseIcon from '@rsuite/icons/Close';
import MenuIcon from '@rsuite/icons/Menu';
import UserMeal from "./user_meal/userMeal";
import UserService from "../../services/user.service";
import CalorieCounter
    from "./calorie_counter/calorieCounter";

const APP_URL = process.env.APP_URL;

const Sidebar = (props) => {
    const [logoutModal, setLogoutModal] = useState(false)
    const {component} = props;
    const params = useParams();

    let menus = [
        {
            title: AuthService.getUser().subscription ? 'وضعیت جسمی' : 'وضعیت جسمی',
            element: AuthService.getUser().subscription ? Dashboards : Physical,
            key: 'dashboard',
            active: true
        },
        // {title: 'برنامه غذایی', element: AuthService.getUser().subscription, key: 'diet', active : AuthService.getUser().subscription === null ? false : true},
        {title: 'ابزارهای سلامت', element: CalorieCounter, key: 'calorie-counter', active: true},
        {title: 'رژیم های خریداری شده', element: Subscription, key: 'subscriptions', active: true},
        {title: 'صفحه اصلی سایت', key: 'changaal', active: true},
        {title: 'قوانین', key: 'tos', active: true},
        // {title: 'دانلود فایل' , key:'pdf' , active :  AuthService.getUser().subscription === null ? false : true},
        {title: 'خروج از حساب کاربری', active: true},
    ];

    menus = menus.filter(function (menu) {
        return menu.active !== false
    });

    const componentIndex = menus.findIndex(menu => menu.key === component && menu.key !== undefined);
    const [activeKey, setActiveKey] = useState(componentIndex >= 0 ? componentIndex : 0);
    const [sidebarStatus, setSidebarStatus] = useState(false);
    const {setContent} = props;

    const navigate = useNavigate();

    useEffect(() => {
        if (componentIndex >= 0) {
            onMenuItemClick(componentIndex);
        }

        if (componentIndex < 0 && component === 'active-subscription') {
            const user = AuthService.getUser();
            const {subscription} = user;
            if (subscription) {
                const periodIndex = subscription.current_period_number - 1;
                setContent(<UserMeal subscriptionId={subscription.id} periodId={periodIndex}/>);
            }
        }

        if (componentIndex < 0 && component === 'user-meal') {
            setActiveKey(2);
            setContent(<UserMeal subscriptionId={params.subscriptionId} periodId={params.periodId}/>);
        }
    }, []);

    return (<div>
            <div className="mobile-sidebar-toggle">
                <div className="mobile-sidebar-name">
                    {`${AuthService.getUser().user.name ? AuthService.getUser().user.name : ''} ${AuthService.getUser().user.surname ? AuthService.getUser().user.surname : ''}`}
                </div>
                <div
                    onClick={e => setSidebarStatus(true)}
                    className="menu-icon">
                    <MenuIcon/>
                </div>
            </div>
            <div className={`sidebar ${sidebarStatus ? 'opened' : ''}`}>
                <div className="sidebar-toggle" onClick={e => setSidebarStatus(false)}>
                    <CloseIcon/>
                </div>
                <div className="user-profile">
                    <div className="user-image">
                        <img src={AuthService.getUser().user.avatar}/>
                    </div>
                    <div className="user-title">
                        {AuthService.getUser().user.name}
                        <div style={{fontWeight: 'normal', fontSize: '.75rem'}}>
                            {AuthService.getUser().user.mobile}
                        </div>
                    </div>
                    {!AuthService.getUser().subscription && !AuthService.getUser().reserved ? <Button appearance="primary"
                                                                   onClick={e => navigate('/subscription-packages')}
                                                                   block>
                        دریافت برنامه
                    </Button> :  (!AuthService.getUser().reserved && AuthService.getUser().subscription.days < 3)  ?
                        <Button appearance="primary"
                                onClick={e => navigate('/subscription-packages')}
                                block>
                            رزرو دوره بعدی
                        </Button>
                        :''


                    }

                </div>
                <Sidenav>
                    <Sidenav.Body>
                        <Nav activeKey={activeKey}>
                            {menus.map((menu, menuIndex) => {
                                return <Nav.Item
                                    className="sidebar-menu-item"
                                    key={menuIndex}
                                    eventKey={menuIndex}
                                    onClick={e => onMenuItemClick(menuIndex)}
                                    icon={<ArrowLeft/>}>
                                    {menu.title}
                                </Nav.Item>
                            })}
                        </Nav>
                    </Sidenav.Body>
                </Sidenav>
            </div>
            <Modal open={logoutModal} onClose={closeLogoutModal} size="xs" keyboard={true}>
                <Modal.Header>
                    <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="mt-1-5 tac">آیا برای خروج از حساب کاربری اطمینان دارید؟</p>
                </Modal.Body>
                <Modal.Footer style={{textAlign: 'center'}}>
                    <div className="modal_buttons_container">
                        <button onClick={closeLogoutModal} className="btn-green-secondary" style={{width: "45%"}}>
                            خیر
                        </button>
                        <button onClick={logout} className="btn-green" style={{width: "45%"}}>
                            بله
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    );

    async function onMenuItemClick(menuIndex) {
        if (menuIndex === menus.length - 1) {
            openLogoutModal();
            return true;
        }


        setActiveKey(menuIndex);

        const menu = menus[menuIndex];

        if (menu.key === 'diet') {
            return true;
        }

        if (menu.key === 'changaal') {
            window.location.href = 'https://changaal.com';
            return true;
        }
        if (menu.key === 'calorie-counter' && window.innerWidth < 763) {
            window.location.href = 'https://tools.changaal.com/';
            return true;
        }

        if (menu.key === 'pdf') {
            let pdfStream = await UserService.getPdfFile()
            const blob = new Blob([pdfStream.data], {type: "application/pdf"});
            //window.open(URL.createObjectURL(blob));
            let pdfURL = window.URL.createObjectURL(blob);
            let tempLink = document.createElement('a');
            tempLink.href = pdfURL;
            tempLink.setAttribute('download', 'help.pdf');
            tempLink.click();
            return true;
        }

        if (menu.key === 'tos') {
            window.location.href = 'https://changaal.com/rules';
            return true;
        }

        const Element = menu.element;
        setSidebarStatus(false);
        setContent(<Element setContent={setContent}/>);
        window.history.pushState({urlPath: `/${menu.key}`}, "", `/${menu.key}`);
    }

    function openLogoutModal() {
        setLogoutModal(true)
    }

    function logout() {
        localStorage.removeItem("error");
        localStorage.removeItem('user');
        localStorage.removeItem('installed');
        window.location.replace('https://changaal.com/');
    }

    function closeLogoutModal() {
        setLogoutModal(false)
    }
}

export default Sidebar;
